import React from 'react'
import ListComponentProto from './list-multi-proto'


export default function renderListInList(id:string, props:any) {
    return (
        <ListComponentProto
            renderMode="list"
            id={id}
            {...props}
        />
    )
}
